import { TableProps } from "../../types";
import React from "react";
import EmptyTable from "./empty-table";
import { PaginationControls } from "./pagination-controls";
import TableSkeleton from "./table-skeleton";
import "./table.css";

const Table = <T extends Record<string, any>>({
  columns,
  dataSource = [],
  rowKey,
  emptyMessage,
  loading = false,
  currentPage = 1,
  itemsPerPage = 10,
  pagination,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  rowClassName,
}: TableProps<T>): React.JSX.Element => {
  if (loading) {
    return <TableSkeleton columns={columns} rowCount={5} />;
  }

  if (!dataSource.length) {
    return (
      <EmptyTable message={emptyMessage || "Нет данных для отображения"} />
    );
  }

  return (
    <div className="custom-table">
      <table>
        <thead>
          <tr>
            <th key="index-column">№</th>
            {columns.map((column) => (
              <th key={column.key}>{column.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataSource.map((record, index) => (
            <tr
              key={String(record[rowKey])}
              className={rowClassName ? rowClassName(record, index) : undefined}
            >
              <td key="index-column-data">
                {(currentPage - 1) * itemsPerPage + index + 1}
              </td>
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render
                    ? column.render(
                        column.dataIndex ? record[column.dataIndex] : undefined,
                        record,
                        index
                      )
                    : column.dataIndex
                    ? record[column.dataIndex]
                    : undefined}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {pagination && totalItems && onPageChange && onItemsPerPageChange && (
        <PaginationControls
          currentPage={pagination.current}
          totalPages={pagination.total}
          itemsPerPage={pagination.pageSize}
          onPageChange={(page) =>
            pagination.onChange(page, pagination.pageSize)
          }
          onItemsPerPageChange={onItemsPerPageChange}
          totalItems={totalItems}
        />
      )}
    </div>
  );
};

export default Table;
